import Immutable from 'immutable';

const Content: {
  name: string,
  values: Immutable.List<any>
} = {
  name: '',
  values: Immutable.List()
};

class ParameterRestriction extends Immutable.Record(Content) {
}

export default ParameterRestriction;
